const apiUrl = process.env.REACT_APP_API_ENDPOINT;

export async function searchDevices(props, filters, start = 0, limit = 10000) {
  const { token, organizationId } = props;
  const { asset_type = [], last_event = [], status = [], tags = [] } = filters;
  let elasticQuery = {
    elasticSearchQuery: {
      bool: {
        must: [
          {
            term: {
              current_owner_id: organizationId,
            },
          },
          {
            terms: {
              asset_mode: ["Device"],
            },
          }
        ],
      },
    },
    limit: limit,
    sort: [
      {
        time_of_log: "asc",
      },
      {
        tag: "desc",
      },
    ],
    page: start,
  };

  // Events - TODO - Elastic - I dont think last_event is ever hit anywhere on the console. Need to create a ticket to look into this
  if (last_event && last_event.length > 0) {
    let lastEventsArray = last_event.map((event) => event);

    elasticQuery.elasticSearchQuery.bool.must.push({
      terms: {
        last_event: lastEventsArray,
      },
    });
  }

  // Tags
  if (tags && tags.length) {
    let tagArray = tags.map((e) => {
      return e.value;
    });

    elasticQuery.elasticSearchQuery.bool.must.push({
      terms: {
        tag: tagArray,
      },
    });
  }

  // Asset Type
  if (asset_type && asset_type.length > 0) {
    elasticQuery.elasticSearchQuery.bool.must.push({
      terms: {
        asset_type,
      },
    });
  }

  // Status
  if (status?.length) {
    const statusArray = status.map((stat) => ({
      match: { "device.status": stat.value },
    }));

    elasticQuery.elasticSearchQuery.bool.must.push({
      nested: {
        path: "device",
        query: {
          bool: {
            should: statusArray,
          },
        },
      },
    });
  }

  const results = await fetch(`${apiUrl}assets/search?includeConsoleExtras=true`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
    body: JSON.stringify(elasticQuery),
  })
    .then((res) => res.json())
    .then((res) => {
      // DEBUG: Log timestamp fields for NFC tags
      if (res.assets && res.assets.length > 0) {
        const nfcTag = res.assets.find(a => a.assetType === "NFC");
        if (nfcTag) {
          console.log("=== NFC TIMESTAMP DEBUG ===");
          console.log("Tag:", nfcTag.tag);
          console.log("assetType:", nfcTag.assetType);
          console.log("timeOfLogLong:", nfcTag.timeOfLogLong);
          console.log("timeModifiedLong:", nfcTag.timeModifiedLong);
          console.log("timeCreatedLong:", nfcTag.timeCreatedLong);
          console.log("timeOfLog:", nfcTag.timeOfLog);
          console.log("timeModified:", nfcTag.timeModified);
          console.log("timeCreated:", nfcTag.timeCreated);
          console.log("=== END DEBUG ===");
        }
      }
      
      // Map latitude/longitude from propertiesMap to root level for consistency
      if (res.assets && res.assets.length > 0) {
        res.assets = res.assets.map((asset) => {
          const latitude = asset.latitude || 
            asset.propertiesMap?.latitude || 
            null;
          const longitude = asset.longitude || 
            asset.propertiesMap?.longitude || 
            null;
          
          return {
            ...asset,
            latitude: latitude ? parseFloat(latitude) : null,
            longitude: longitude ? parseFloat(longitude) : null,
          };
        });
      }
      return res;
    })
    .catch((err) => {
      console.log(err);
      console.log(elasticQuery);
      return {
        error: "Failed to fetch data, please contact system administrator.",
      };
    });

  return results;
}

export async function searchDeviceAssets(
  props,
  joinedDeviceAssetIds = [],
  limit = 300
) {
  const { token, organizationId } = props;
  
  // Don't make API call if no device IDs provided
  if (!joinedDeviceAssetIds || joinedDeviceAssetIds.length === 0) {
    return { assets: [], count: 0 };
  }
  
  const elasticQuery = {
    elasticSearchQuery: {
      bool: {
        must: [
          {
            term: {
              current_owner_id: organizationId,
            },
          },
          {
            terms: {
              parent_id: joinedDeviceAssetIds,
            },
          },
        ],
      },
    },
    sort: [
      {
        time_of_log: "asc",
      },
      {
        tag: "desc",
      },
    ],
    limit: limit,
  };

  const results = await fetch(`${apiUrl}assets/search?includeConsoleExtras=true`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
    body: JSON.stringify(elasticQuery),
  })
    .then((response) => response.json())
    .then((json) => {
      // Map latitude/longitude from propertiesMap to root level for consistency
      if (json.assets && json.assets.length > 0) {
        json.assets = json.assets.map((asset) => {
          const latitude = asset.latitude || 
            asset.propertiesMap?.latitude || 
            null;
          const longitude = asset.longitude || 
            asset.propertiesMap?.longitude || 
            null;
          
          return {
            ...asset,
            latitude: latitude ? parseFloat(latitude) : null,
            longitude: longitude ? parseFloat(longitude) : null,
          };
        });
      }
      return json;
    })
    .catch((err) => {
      console.log(err);
      console.log(elasticQuery);
      return {
        error: "Failed to fetch data, please contact system administrator.",
      };
    });

  return results;
}

export async function buildDeviceAssetsMap(props, deviceList) {
  const deviceAssetIds =
    deviceList && deviceList.length > 0
      ? deviceList
        .map((d) => {
          if (d.assetId) {
            return d.assetId;
          }
          return null;
        })
        .filter((el) => el !== null)
      : [];

  if (deviceAssetIds.length > 0) {
    const deviceAssetsMap = await searchDeviceAssets(
      props,
      deviceAssetIds
    ).then((res) => {
      if (res.error || !res.assets) {
        return {};
      }

      let deviceAssetsMap = {};
      res.assets.forEach((ass) => {
        if (ass.parentId) {
          if (!deviceAssetsMap[ass.parentId]) {
            deviceAssetsMap[ass.parentId] = [];
          }
          deviceAssetsMap[ass.parentId].push(ass);
        }
      });

      return deviceAssetsMap;
    });
    return deviceAssetsMap;
  }

  return {};
}

export const saveFilterSettings = async (props, filters) => {
  const { token, appUserId } = props;
  const payload = {
    propertiesMap: {
      deviceTableSettings: filters,
    },
  };
  const results = await fetch(`${apiUrl}appUsers/${appUserId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
    body: JSON.stringify(payload),
  })
    .then((results) => results.json())
    .then((results) => results)
    .catch((err) => {
      console.log(err);
      console.log(payload);
      return {
        error: "Failed to save settings, please contact system administrator.",
      };
    });

  return results;
};

export const devices = {
  searchDevices,
  buildDeviceAssetsMap,
  searchDeviceAssets,
  saveFilterSettings,
};
